import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { NULLISH_VALUE } from '~/common/constants';
import { LabeledDataRow } from '~/components/LabeledDataRow/LabeledDataRow';

export interface NegotiationContactData {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  mobile?: string | null;
  phone?: string | null;
  language?: string | null;
}

export interface NegotiationContactProps {
  data?: NegotiationContactData | null;
  loading?: boolean;
}

export const NegotiationContact = ({ data, loading }: NegotiationContactProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'NegotiationContact' });
  const { t: tLanguage } = useTranslation(undefined, { keyPrefix: 'language' });

  return (
    <Grid
      container
      direction="column"
      spacing={4}
      sx={{
        justifyContent: 'flex-start',
      }}
    >
      <Grid container size={12}>
        <LabeledDataRow
          labelColumnSize={6}
          loading={loading}
          label={t('email')}
          body={data?.email || NULLISH_VALUE}
          bodyProps={{ sx: { whiteSpace: 'wrap', wordBreak: 'break-word' } }}
        />
      </Grid>
      <Grid container size={12}>
        <LabeledDataRow
          labelColumnSize={6}
          loading={loading}
          label={t('firstName')}
          body={data?.firstName || NULLISH_VALUE}
        />
      </Grid>
      <Grid container size={12}>
        <LabeledDataRow
          labelColumnSize={6}
          loading={loading}
          label={t('lastName')}
          body={data?.lastName || NULLISH_VALUE}
        />
      </Grid>
      <Grid container size={12}>
        <LabeledDataRow
          labelColumnSize={6}
          loading={loading}
          label={t('mobile')}
          body={data?.mobile || NULLISH_VALUE}
        />
      </Grid>
      <Grid container size={12}>
        <LabeledDataRow labelColumnSize={6} loading={loading} label={t('phone')} body={data?.phone || NULLISH_VALUE} />
      </Grid>
      <Grid container size={12}>
        <LabeledDataRow
          labelColumnSize={6}
          loading={loading}
          label={t('language')}
          body={data?.language ? tLanguage(data?.language) : NULLISH_VALUE}
        />
      </Grid>
    </Grid>
  );
};
